import { render, staticRenderFns } from "./BackofficeNotAllowed.vue?vue&type=template&id=49e1ca03&scoped=true"
import script from "./BackofficeNotAllowed.vue?vue&type=script&lang=js"
export * from "./BackofficeNotAllowed.vue?vue&type=script&lang=js"
import style0 from "./BackofficeNotAllowed.vue?vue&type=style&index=0&id=49e1ca03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e1ca03",
  null
  
)

export default component.exports